import {
	PATHS,
} from '@routes/paths';
import {
	lazy,
} from 'react';

// LOGIN STEPS
const PageAuthSMS = lazy(() =>
	import('@layouts/Pages/PageLogin/step-auth-sms').then((module) => ({
		default: module.PageAuthSMS,
	})),
);
const StepLoginRoot = lazy(() =>
	import('@layouts/Pages/PageLogin/step-login').then((module) => ({
		default: module.StepLogin,
	})),
);
const StepPasswordForgot = lazy(() =>
	import('@layouts/Pages/PageLogin/step-password-forgot').then((module) => ({
		default: module.PagePasswordForgot,
	})),
);
const StepPasswordEmailSent = lazy(() =>
	import('@layouts/Pages/PageLogin/step-password-email-sent').then((module) => ({
		default: module.PagePasswordEmailSent,
	})),
);
const StepPasswordEdit = lazy(() =>
	import('@layouts/Pages/PageLogin/step-password-edit').then((module) => ({
		default: module.PagePasswordEdit,
	})),
);
const StepPasswordSuccess = lazy(() =>
	import('@layouts/Pages/PageLogin/step-password-success').then((module) => ({
		default: module.PagePasswordSuccess,
	})),
);
const StepUnknownIpAddress = lazy(() =>
	import('@layouts/Pages/PageLogin/step-unknown-ip-address').then((module) => ({
		default: module.PageUnknownIpAddress,
	})),
);

export const LOGIN_ROUTES = [
	{
		element: <StepLoginRoot />,
		index: true,
	},
	{
		element: <PageAuthSMS />,
		path: PATHS.LOGIN.SUCCESS_STEP_2FA_SMS,
	},
	{
		element: <StepPasswordEdit />,
		path: PATHS.LOGIN.PASSWORD_EDIT,
	},
	{
		element: <StepPasswordSuccess />,
		path: PATHS.LOGIN.PASSWORD_SUCCESS,
	},
	{
		element: <StepPasswordEmailSent />,
		path: PATHS.LOGIN.PASSWORD_EMAIL_SENT,
	},
	{
		element: <StepPasswordForgot />,
		path: PATHS.LOGIN.PASSWORD_FORGOT,
	},
	{
		element: <StepUnknownIpAddress />,
		path: PATHS.LOGIN.ERROR_AUTH_IP,
	},
];
